import { render, staticRenderFns } from "./stockadjust.vue?vue&type=template&id=06f604de"
import script from "./stockadjust.vue?vue&type=script&lang=js"
export * from "./stockadjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports